import { useRef } from "react";
import { useSelector } from "react-redux";
import { CardVariantsEnum } from "../../../stories/Components/Card/interface";
import { FeatureAttribution } from "../../../stories/shared/interfaces/featureAttribution";
import LayoutFactory from "../../LayoutFactory/component";
import { VIEWPORT_CLASS_LARGE } from "../../../utils/page/library";
import useViewport from "../../../hooks/useViewport";
import { PathConfig, RootState, ContentItems } from "../interface";
import { PATHS_WITH_NEWS_BAR } from "../constants";
import classes from "./newsLineup.module.scss";

const NewsLineup = () => {
    const newsList: ContentItems[] = useSelector(
        (state: RootState) => state?.singleLineup?.content
    );
    const linkCardData: PathConfig = useSelector((state: RootState) => {
        return PATHS_WITH_NEWS_BAR[state.app.path];
    });

    const layout = {
        name: "card-grid",
        columns: 5,
        variant: CardVariantsEnum.TEXT_WITH_LINK,
        loadMore: {
            enabled: false,
        },
        isFlexible: false,
    };

    const mobileOnlyMoreCard = {
        id: "news-bar-more",
        title: linkCardData.moreCardTitle || "More from CBC News",
        url: linkCardData.url,
        external: false,
        variant: CardVariantsEnum.TEXT_WITH_LINK_AND_ICON,
    };

    const ref = useRef();
    const viewport: string = useViewport(ref, VIEWPORT_CLASS_LARGE) as string;

    const itemsToRender = [...newsList, mobileOnlyMoreCard];

    if (viewport === VIEWPORT_CLASS_LARGE) {
        itemsToRender.splice(4);
        layout.columns = 4;
    }
    const featureAttribution: FeatureAttribution = {
        name: "swimlane",
        instance: "news-bar",
    };
    return (
        <div className={classes.newsLineupContainer}>
            <LayoutFactory
                featureAttributionData={featureAttribution}
                layout={layout}
                items={itemsToRender}
            />
        </div>
    );
};

export default NewsLineup;
